import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopCategoriesApi from '../generated/api/ShopCategories';

export default (service: Servicelayer) => ({
  ...ShopCategoriesApi(service),

  // Add custom calls here

});
